import * as React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import ModalBackground from '@components/ui/modal';
import Dialog from '@components/ui/dialog';
import { ButtonType } from '@components/actions/button/index';

import AppState from '@webapp/store/state';
import { UIState } from '@webapp/store/ui/state';
import { DialogAction } from '@webapp/types/ui/dialog-action';
import { CloseDialog } from '@webapp/store/ui/action-creators';
import styled from 'styled-components';

interface ModalDialogsCtrlProps {
  dialogs: UIState['dialogs'];
  closeDialog: (key: string) => CloseDialog;
}

const mapStateToProps = (state: AppState) => ({
  dialogs: state.ui.dialogs,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  closeDialog: (key: string) => dispatch(new CloseDialog(key)),
});

export const ModalDialogsCtrl: React.FC<ModalDialogsCtrlProps> = (props) => {
  return (
    <>
      {Object.keys(props.dialogs).map((key) => {
        const config = props.dialogs[key];

        return (
          <StyledModalBackground
            key={`dialog-${key}`}
            active={!!config.open}
            zIndex={config.zIndex}
          >
            <Dialog
              dialogKey={key}
              title={config.title}
              text={config.text}
              component={config.component}
              componentProps={config.componentProps}
              actions={config.actions as DialogAction<ButtonType>[]}
              callback={(value: any) => {
                if (config.callback) {
                  config.callback(value);
                }

                props.closeDialog(key);
              }}
            />
          </StyledModalBackground>
        );
      })}
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalDialogsCtrl);

const StyledModalBackground = styled(ModalBackground)`
  z-index: ${({ theme, zIndex }) => zIndex || theme.zIndices.dialogs};
`;
